import { Component, OnInit, ViewChild } from '@angular/core';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SimpleCommunityWithOpenTicketsCount } from '@core/models/simple-community-with-open-tickets-count.model';
import { CommonDataForSettingsService } from '@core/services/common-data-for-settings.service';
import { UserDataService } from '@sb-tools/typescript/services/user-data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgClass } from '@angular/common';
import { UiSwitchModule } from 'ngx-ui-switch';
import { TruncatePipe } from '@sb-tools/typescript/pipes/truncate.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-community-switcher',
    templateUrl: './community-switcher.component.html',
    styleUrls: ['./community-switcher.component.scss'],
    imports: [BsDropdownModule, NgClass, UiSwitchModule, TruncatePipe, TranslatePipe],
})
export class CommunitySwitcherComponent implements OnInit {
    @ViewChild('dropdown', { static: false }) private dropdown: BsDropdownDirective;

    communities: SimpleCommunityWithOpenTicketsCount[];
    currentCommunityDisplayName: string;
    currentCommunityName: string;
    userCommunitiesKeyword: string;

    private unsubscriber = new Subject<void>();

    constructor(
        public commonDataForSettingsService: CommonDataForSettingsService,
        private userDataService: UserDataService,
    ) {}

    ngOnInit() {
        this.currentCommunityName = this.commonDataForSettingsService.communityName;
        this.initCommunities();
    }

    getFilteredCommunities() {
        if (this.userCommunitiesKeyword) {
            const keyword = this.userCommunitiesKeyword.toLowerCase();

            return this.communities.filter((item) => {
                return (
                    item.communityDisplayName.toLowerCase().indexOf(keyword) !== -1 ||
                    item.communityName.toLowerCase().indexOf(keyword) !== -1
                );
            });
        } else {
            return this.communities;
        }
    }

    private initCommunities() {
        this.userDataService
            .getCommunities()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((communities: SimpleCommunityWithOpenTicketsCount[]) => {
                communities.forEach((community: SimpleCommunityWithOpenTicketsCount) => {
                    community.link = window.location.origin + '/' + community.communityName + '/community/settings';
                });

                this.communities = communities;
                this.currentCommunityDisplayName = this.communities.find(
                    (community) => community.communityName === this.currentCommunityName,
                )?.communityDisplayName;
            });
    }
}
